import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import type { Tile } from "../../shared/protocol.ts";
import { CHART_THEME, compact } from "../format.ts";
import { ChartTooltip } from "./ChartTooltip.tsx";

/** Trend over time. Filled area reads as growth from across a room. */
export function LineTile({ tile }: { tile: Tile }) {
  const data = tile.labels.map((label, i) => ({ label, value: tile.values[i] ?? 0 }));
  const gid = `line-${tile.id}`;
  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={data} margin={{ top: 10, right: 4, bottom: 0, left: 4 }}>
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={CHART_THEME.primary} stopOpacity={0.55} />
            <stop offset="100%" stopColor={CHART_THEME.primary} stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid stroke={CHART_THEME.grid} vertical={false} />
        <XAxis
          dataKey="label"
          reversed
          tickLine={false}
          axisLine={false}
          interval={0}
          tick={{ fill: CHART_THEME.label, fontSize: 13, fontFamily: CHART_THEME.font }}
        />
        <YAxis
          orientation="right"
          tickLine={false}
          axisLine={false}
          width={58}
          tickFormatter={compact}
          tick={{ fill: CHART_THEME.label, fontSize: 12, fontFamily: CHART_THEME.font }}
        />
        <Tooltip content={<ChartTooltip unit={tile.unit} />} />
        <Area
          type="monotone"
          dataKey="value"
          stroke={CHART_THEME.primary}
          strokeWidth={3}
          fill={`url(#${gid})`}
          animationDuration={1100}
          dot={{ r: 4, fill: CHART_THEME.surface, stroke: CHART_THEME.primary, strokeWidth: 2.5 }}
          activeDot={{ r: 6, fill: CHART_THEME.primary }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
